import { Box } from "@mui/material";
import LayoutItems from "../Layout/LayoutItems";
import { SidebarExtensionProps } from "./types";

export const SidebarExtension = ({ 
    items,
}: SidebarExtensionProps) => {

    return (
        <Box 
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                padding: "24px 16px",
                borderRight: "1px solid #DBE0E2",
                "@media(max-width: 900px)": {
                    padding: "12px",
                    flexDirection: "row",
                    overflowX: 'scroll',
                    borderRight: 0,
                    borderBottom: "1px solid #DBE0E2",
                    scrollbarWidth: "none",
                    "-ms-overflow-style": "none",
                    "::-webkit-scrollbar": {
                        display: "none",
                    },
                },
            }}
        >
            {items
                .map((item, index) => (
                <LayoutItems
                    key={index}
                    item={item}
                    selected={item.selected}
                    onClick={item.onClick}
                />
            ))}
        </Box>
    )
}